(() => {
  'use strict';
  const toggle=document.querySelector('[data-toggle-menu]');
  toggle?.addEventListener('click',()=>{const menu=document.getElementById('mobile-menu');const open=menu.classList.toggle('open');toggle.setAttribute('aria-expanded',String(open));toggle.setAttribute('aria-label',open?'Close navigation':'Open navigation');});
  document.querySelectorAll('#mobile-menu a').forEach(link=>link.addEventListener('click',()=>{document.getElementById('mobile-menu').classList.remove('open');toggle.setAttribute('aria-expanded','false');}));
  document.querySelectorAll('[data-variant-select]').forEach(select=>select.addEventListener('change',()=>{
    const option=select.selectedOptions[0];
    const form=select.closest('form');
    const button=form.querySelector('[data-add-product]');
    const available=option.dataset.available==='true';
    button.disabled=!available;button.textContent=available?'Add to bag':'Sold out';
    document.getElementById('product-price').textContent=option.dataset.price;
    const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
  }));
})();
